import { useEffect, useState } from "react";
import "./SignPad.scss";
import SignaturePad from "signature_pad";
import AppButton from "src/components/base/Button/Button";

interface SignatureProps {
    onSignature: any;
}

export const SignatureSpace = ({ onSignature }: SignatureProps) => {
    const [hasSignature, setHasSignature] = useState(false);
    const [loading, setLoading] = useState(false);

    let signaturePad: SignaturePad;

    const signPDF = async () => {
        setLoading(true);
        const canvas: any = document.getElementById("signature-pad");
        const base64code = canvas.toDataURL();

        onSignature(base64code);
    };

    const initSignPad = () => {
        const canvas: any = document.getElementById("signature-pad");

        if (!canvas) return;

        // Adjust canvas coordinate space taking into account pixel ratio,
        // to make it look crisp on mobile devices.
        // This also causes canvas to be cleared.
        function resizeCanvas() {
            // When zoomed out to less than 100%, for some very strange reason,
            // some browsers report devicePixelRatio as less than 1
            // and only part of the canvas is cleared then.
            const ratio = Math.max(window.devicePixelRatio || 1, 1);

            canvas.width = canvas.offsetWidth * ratio;
            canvas.height = canvas.offsetHeight * ratio;
            canvas.getContext("2d").scale(ratio, ratio);
        }

        window.onresize = resizeCanvas;
        resizeCanvas();

        signaturePad = new SignaturePad(canvas, {
            backgroundColor: "rgb(255, 255, 255)", // necessary for saving image as JPEG; can be removed is only saving as PNG or SVG
        });

        document
            .getElementById("clear")
            // eslint-disable-next-line space-before-function-paren
            ?.addEventListener("click", function () {
                signaturePad.clear();
                setHasSignature(false);
                const ctx: any = canvas.getContext("2d");

                ctx.globalCompositeOperation = "source-over"; // default value
            });

        signaturePad.addEventListener(
            "endStroke",
            () => {
                setHasSignature(true);
            },
            { once: false }
        );
    };

    useEffect(() => {
        initSignPad();
    }, []);

    return (
        <div className="signpad">
            <canvas id="signature-pad" className="signature-pad" />
            <button
                disabled={loading || !hasSignature}
                id="clear"
                className="clear-btn"
            >
                Clear Signature
            </button>
            <AppButton
                label="Confirm"
                onClick={signPDF}
                isProcessing={loading}
                disabled={loading || !hasSignature}
                className="confirm-btn"
            />
        </div>
    );
};
